import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Pressable, Text, View } from 'react-native'
import AppConfig from 'config/AppConfig'
import { cofidisMockFormValues } from './cofidisMockData'
import type { CofidisMonthlyApplicationFormValues } from './types'
import type { CofidisSectionConfig } from './sections'
import Button from '@ui/buttons/Button'
import cn from '@ui/utils/cn'

type DevFillSectionButtonProps = {
  section: CofidisSectionConfig
  className?: string
}

/**
 * DEV-only button that fills the section with valid mock data.
 * Only rendered when AppConfig.isDev; positioned absolutely so it does not affect layout.
 */
export function DevFillSectionButton({
  section,
  className,
}: DevFillSectionButtonProps) {
  const { setValue } = useFormContext<CofidisMonthlyApplicationFormValues>()

  if (!AppConfig.isDev) {
    return null
  }

  const fillSection = () => {
    section.fields.forEach((field) => {
      const value = cofidisMockFormValues[field]
      if (value !== undefined) {
        setValue(field, value as never, { shouldValidate: true })
      }
    })
  }

  return (
    <View
      pointerEvents="box-none"
      className={cn(
        'absolute right-0 top-0 z-10 p-2 opacity-10 transition-all hover:opacity-100',
        className
      )}
    >
      <Button
        size="xs"
        variant="outlined"
        iconStart="pencil"
        icon="only"
        onPress={fillSection}
      />
    </View>
  )
}
